var _defs, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamorphose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons8-metamorphose",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.016,
    y1: 0.016,
    x2: 0.984,
    y2: 0.984,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a235d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#831bb3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.077,
    y1: 0.077,
    x2: 0.923,
    y2: 0.923,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: -1.021,
    x2: 0.5,
    y2: 1.274,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3ffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63daff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4018",
    "data-name": "Path 4018",
    d: "M5.868,5H19.763a.869.869,0,0,1,.868.868V19.763a.869.869,0,0,1-.868.868H5.868A.869.869,0,0,1,5,19.763V5.868A.869.869,0,0,1,5.868,5Z",
    transform: "translate(-5 -5)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4019",
    "data-name": "Path 4019",
    d: "M29.5,25.421A4.217,4.217,0,0,1,25.158,29.5H17.342A4.217,4.217,0,0,1,13,25.421V18.079A4.217,4.217,0,0,1,17.342,14h7.816A4.217,4.217,0,0,1,29.5,18.079Z",
    transform: "translate(-6.474 -6.184)",
    fill: "url(#linear-gradient-2)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_434",
    "data-name": "Ellipse 434",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(15 15)",
    fill: "url(#linear-gradient-3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamorphose);
export default __webpack_public_path__ + "static/media/metamorphose.81aa428cb04087d024d149f2d6080405.svg";
export { ForwardRef as ReactComponent };